import FormattedMessage from 'I18n/components/FormattedMessage';
import { Component } from 'react';
import styled from 'styled-components';
import VizExIcon from 'visitor-ui-component-library/icon/VizExIcon';

// @ts-ignore Untyped
import getMeetingsLinkUrl from 'conversations-internal-schema/responders/operators/getMeetingsLinkUrl';
// @ts-ignore Untyped
import getMeetingsLinkText from 'conversations-internal-schema/responders/operators/getMeetingsLinkText';
import SVGDate from 'visitor-ui-component-library-icons/icons/SVGDate';
import VizExLink from 'visitor-ui-component-library/link/VizExLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const WidgetMeetingsLinkButtonWrapper = styled.div.withConfig({
  displayName: "MeetingsLinkButton__WidgetMeetingsLinkButtonWrapper"
})(["padding-left:16px;padding-right:16px;display:flex;flex-direction:column;flex-shrink:0;height:44px;align-items:center;justify-content:center;"]);
class MeetingsLinkButton extends Component {
  constructor(props) {
    super(props);
    this.handleOnClick = this.handleOnClick.bind(this);
  }
  handleOnClick() {
    const {
      clickedMeetingsLink,
      assignedResponder
    } = this.props;
    const meetingsLinkUrl = getMeetingsLinkUrl(assignedResponder);
    window.open(`${meetingsLinkUrl}?fromMessages=true`, '_blank');
    clickedMeetingsLink();
  }
  render() {
    const {
      shouldShowMeetingsLink,
      assignedResponder
    } = this.props;
    const meetingsLinkText = getMeetingsLinkText(assignedResponder);
    if (!shouldShowMeetingsLink) {
      return null;
    }
    return /*#__PURE__*/_jsx(WidgetMeetingsLinkButtonWrapper, {
      children: /*#__PURE__*/_jsxs(VizExLink, {
        className: "align-center justify-center",
        onPress: this.handleOnClick,
        children: [/*#__PURE__*/_jsx(VizExIcon, {
          icon: /*#__PURE__*/_jsx(SVGDate, {}),
          className: "m-right-1"
        }), meetingsLinkText || /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-visitor-ui.default.meetingsLinkText"
        })]
      })
    });
  }
}
MeetingsLinkButton.displayName = 'MeetingsLinkButton';
export default MeetingsLinkButton;